import { useContext } from 'react';
import { TabsContext } from "./TabsContext";
import { getPanelId, getTabId } from "./get-accessibility-ids";
export function useTabPanel(index) {
  var _useContext = useContext(TabsContext),
      id = _useContext.id,
      value = _useContext.value;

  return {
    bind: {
      id: getPanelId(id, index),
      'aria-labelledby': getTabId(id, index),
      role: 'tabpanel'
    },
    isSelected: value === index
  };
}